/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/10/2023
 */

import { Backdrop, Button, CircularProgress, Grid, OutlinedInput, Paper, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { isMobile } from 'react-device-detect';
import styles from "./DetailsStep.module.css"
import SubCategoryCard from './SubCategoryCard';
import { useGetAllFrequenciesQuery } from '../../Store/Services/FrequencyService';
import CheckoutContext from '../../Context/CheckoutContext';
import { SET_FREQUENCY, SET_SUB_CATEGORY, SET_TOTAL } from '../../Pages/CheckoutPage';

const DetailsStep = ({ categories, setIsDisabled }) => {

    const { data: frequency, isLoading: isFreqLoading, isSuccess: isFreqSuccess } = useGetAllFrequenciesQuery();

    const { checkoutData, dispatch } = useContext(CheckoutContext);

    useEffect(() => {
        if (isFreqSuccess && !isFreqLoading) {
            dispatch({ type: SET_FREQUENCY, payload: frequency[0].freqId})
        }
    }, [frequency])

    useEffect(() => {
        if (categories && categories?.length!==0) {
            dispatch({ type: SET_SUB_CATEGORY, payload: {
                catId: categories[0].catId,
                subCatName: categories[0].catDisplay
            }})
            dispatch({ type: SET_TOTAL, payload: categories[0].price})
        }
    }, [categories])

    const onFreqChange = (id) => {
        dispatch({ type: SET_FREQUENCY, payload: id})
    }

    useEffect(() => {
        const UpdateDisabled = () => {
            if(checkoutData.freqId && checkoutData.catId) {
                setIsDisabled(false)
            } else {
                setIsDisabled(true)
            }
        }
        UpdateDisabled()
    }, [checkoutData])


    return (
        <div className={styles.container}>
            {isFreqLoading && (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isFreqLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <Paper className={styles.paper} elevation={isMobile? 0: 3}>
                        <Typography className={styles.topic}>Service Details</Typography>
                        {/* <hr className={styles.line}/> */}
                        <div className={styles.detailsContainer}>
                            {categories?.map(cat => (
                                <div key={cat.catId}>
                                    <SubCategoryCard cat={cat} />
                                    {/* <hr className={styles.line}/> */}
                                </div>
                            ))}
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper className={styles.paper} elevation={isMobile? 0: 3}>
                        <Typography className={styles.topic}>Choose your Frequency</Typography>
                        <div className={styles.frequencyContainer}>
                            {isFreqSuccess && frequency.map(data => (
                                <div
                                    key={data.freqId}
                                    onClick={() => onFreqChange(data.freqId)}
                                    className={`${styles.frequencyCard} ${checkoutData.freqId == data.freqId && styles.selectedFreq}` }
                                >
                                    <Typography className={styles.itemPrice}>{data.freqName}</Typography>
                                    <Typography className={styles.frequencyDetails}>{data.freqDesc}</Typography>
                                    {data.freqOff != 0 && <Typography className={styles.frequencyOff}>{Math.trunc(data.freqOff)}% Off</Typography>}
                                </div>
                            ))}
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

export default DetailsStep